export enum SuccessfulVerificationLocalizationId {
    SuccessfulVerificationTitle = "sign-in-verify-email.successfully_verified_email_title",
    SuccessfulVerificationText = "sign-in-verify-email.successfully_verified_email_text",
    ContinueButton = "sign-in-verify-email.continue_button",
    StepPicture = "sign-in-verify-email.step_picture",
}
